import React, { Suspense, lazy } from 'react';
import Loader from 'wrapper/loader';

const NotFound = lazy(() => import('components/404'));
const Dashboard = lazy(() => import('@/pages/b2c/dashboard'));
const Documents = lazy(() => import('@/pages/b2c/application/documents'));
const HelpSupport = lazy(() => import('@/pages/shared/help-support'));
const SupportDocs = lazy(() => import('@/pages/b2c/support-docs'));
const Login = lazy(() => import('@/pages/shared/auth/login/Login'));
const Pipeline = lazy(() => import('@/pages/b2c/pipeline'));
const Profile = lazy(() => import('@/pages/b2c/profile'));
const Tools = lazy(() => import('@/pages/b2c/tools'));
const ConsumerOnboard = lazy(() => import('@/pages/b2c/onboarding/ConsumerOnboard'));
const B2CChatPanel = lazy(() => import('@/pages/b2c/chat/B2CChatPanel'));

const suspenseFallback = <Loader />;

const consumerRoutes = [
  {
    path: '/',
    element: (
      <Suspense fallback={suspenseFallback}>
        <Login />
      </Suspense>
    ),
    children: [
      {
        path: 'onboard',
        element: (
          <Suspense fallback={suspenseFallback}>
            <ConsumerOnboard />
          </Suspense>
        ),
      },
      {
        path: 'documents',
        element: (
          <Suspense fallback={suspenseFallback}>
            <Documents />
          </Suspense>
        ),
      },
      {
        path: 'tools',
        element: (
          <Suspense fallback={suspenseFallback}>
            <Tools />
          </Suspense>
        ),
      },
      {
        path: 'dashboard',
        element: (
          <Suspense fallback={suspenseFallback}>
            <Dashboard />
          </Suspense>
        ),
      },
      {
        path: 'profile',
        element: (
          <Suspense fallback={suspenseFallback}>
            <Profile />
          </Suspense>
        ),
      },
      {
        path: 'pipeline',
        element: (
          <Suspense fallback={suspenseFallback}>
            <Pipeline />
          </Suspense>
        ),
      },
      {
        path: 'chat',
        element: (
          <Suspense fallback={suspenseFallback}>
            <B2CChatPanel />
          </Suspense>
        ),
      },
      {
        path: 'help-support',
        element: (
          <Suspense fallback={suspenseFallback}>
            <HelpSupport />
          </Suspense>
        ),
      },
      {
        path: 'support-docs',
        element: (
          <Suspense fallback={suspenseFallback}>
            <SupportDocs />
          </Suspense>
        ),
      },
      {
        path: 'support-docs/:topic',
        element: (
          <Suspense fallback={suspenseFallback}>
            <SupportDocs />
          </Suspense>
        ),
      },
      {
        path: '*',
        element: (
          <Suspense fallback={suspenseFallback}>
            <NotFound />
          </Suspense>
        ),
      },
    ],
  },
];

export default consumerRoutes;
